import { render, staticRenderFns } from "./WhatsappOffline.vue?vue&type=template&id=74745c96"
import script from "./WhatsappOffline.vue?vue&type=script&lang=js"
export * from "./WhatsappOffline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports